import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { connect } from "react-redux";
import MuiButton from "../../components/muiButton/MuiButton";
import { theme } from "../App";
import MuiTextField from "../../components/muiTextField/MuiTextField";
import AutoCompleteMultiSelect from "../../components/autoCompleteComponent/AutoCompleteMultiSelect";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfluencerPlatformAction from "../../stores/influencerPlatformAccounts/InfluencerPlatformAction";
import axios from "axios";
import environment from "environment";
import YouTubeIcon from "@mui/icons-material/YouTube";
import jwtDecode from "jwt-decode";
// mapstateto props function
const mapDispatchToProps = (dispatch) => {
  return {};
};

const PostInfluencersPlatformAccounts = (props) => {
  let initial = {};
  if (props.edit) {
    initial = {
      account_url: props.influencerPlatformEditData.rowData._source.account_url,
      channel_url: props.influencerPlatformEditData.rowData._source.channel_url,
      enabled: props.influencerPlatformEditData.rowData._source.enabled,
      whatsapp_number:
        props.influencerPlatformEditData.rowData._source.whatsapp_number,
      platform: props.influencerPlatformEditData.rowData._source.platform,

      enabled: props.influencerPlatformEditData.rowData._source.enabled,
    };
  } else {
    initial = {
      account_url: [],
      channel_url: [],
      platform: "",
      whatsapp_number: "",
      enabled: true,
    };
  }

  const [url_value, setUrl_value] = useState("");

  const [theArray, setTheArray] = useState([]);

  useEffect(() => {
    if (props.open && props.edit) {
      const InitialArray = [];
      if (props.influencerPlatformEditData.platform === "Youtube") {
        props.influencerPlatformEditData.rowData &&
          props.influencerPlatformEditData.rowData._source.channel_url &&
          props.influencerPlatformEditData.rowData._source.channel_url.map(
            (item) => {
              return InitialArray.push(item);
            }
          );
      } else {
        props.influencerPlatformEditData.rowData &&
          props.influencerPlatformEditData.rowData._source.account_url &&
          props.influencerPlatformEditData.rowData._source.account_url.map(
            (item) => {
              return InitialArray.push(item);
            }
          );
      }

      setTheArray(InitialArray);
    }
    if (!props.open) {
      setTheArray([]);
      setUrl_value("");
    }
  }, [props.open]);

  const url_value_handlechnage = (event) => {
    if (
      event.target.value.length > 1 ||
      event.target.value !== null ||
      event.target.value.trim()
    ) {
      setUrl_value(event.target.value);
    }
  };

  const addEntryClick = () => {
    if (url_value != "" && url_value.trim() != "") {
      setTheArray([...theArray, url_value]);
      setUrl_value("");
    } else if (url_value === "" && url_value.trim() === "") {
      alert("Provide proper URL");
    }
    setUrl_value("");
  };

  const [loading, setLoading] = useState(false);

  const returnKeyname = (platform) => {
    if (platform === "Quora") {
      return "Question Url";
    }
    if (platform === "Facebook" || platform === "Instagram") {
      return "Account Url";
    }
    if (platform === "Twitter" || platform === "Playstore") {
      return "Account id";
    }
    if (platform === "Youtube") {
      return "Channel Url";
    }
  };

  // Facebook or Instagram Oauth method

  let requestFacebookToken = () => {
    axios
      .get(`${environment.api.baseApi}/influencer_facebook_login`)
      .then((res) => {
        const response = res.data;

        const token = response.url;
        window.location.assign(token);
      });
  };

  // Youtube Oauth method

  // youtube_o_auth
  let requestYoutubeToken = () => {
    axios
      .get(`${environment.api.baseApi}/influencer_youtube_login`)
      .then((res) => {
        const response = res.data;

        const token = response.url;
        window.location.assign(token);

        // window.open(token, "");
      });
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
      <Formik
        initialValues={initial}
        enableReinitialize={true}
        validateOnBlur={true}
        validate={(values) => {
          var errors = {};

          if (theArray.length == 0) {
            errors.account_url = "URL is required";
            errors.channel_url = "URL is required";
          }

          if (!values.platform) {
            errors.platform = "Select Platform";
          }

          return errors;
        }}
        validateOnChange
        onSubmit={(values) => {
          let obj = {
            influencer: values.influencer,

            enabled: values.enabled,
          };

          Object.assign(
            obj,

            (values.platform.platform_name === "Facebook" ||
              values.platform.platform_name === "Instagram") && {
              account_url: theArray,
            },
            values.platform.platform_name === "Youtube" && {
              channel_url: theArray,
            },
            values.platform.platform_name === "Quora" && {
              question_url: theArray[0],
            },
            values.platform.platform_name === "Playstore" ||
              (values.platform.platform_name === "Twitter" && {
                account_id: theArray[0],
              }),
            values.platform.platform_name === "Whatsapp" && {
              whatsapp_number: values.whatsapp_number,
            },

            !props.edit && {
              platform: values.platform,
            }
          );

          if (props.edit) {
            values.platform.platform_name === "Facebook" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPutInfluencerFacebookAccount(
                    JSON.stringify(obj),
                    props.influencerPlatformEditData
                      .influencer_accounts_unique_id
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Instagram" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPuttInfluencerInstagramAccount(
                    JSON.stringify(obj),
                    props.influencerPlatformEditData
                      .influencer_accounts_unique_id
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Youtube" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPutInfluencerYoutubeAccount(
                    JSON.stringify(obj),
                    props.influencerPlatformEditData
                      .influencer_accounts_unique_id
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Quora" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPutInfluencerQuoraAccount(
                    JSON.stringify(obj),
                    props.influencerPlatformEditData
                      .influencer_accounts_unique_id
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Playstore" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPutInfluencerPlaystoreAccount(
                    JSON.stringify(obj),
                    props.influencerPlatformEditData
                      .influencer_accounts_unique_id
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Twitter" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPutInfluencerTwitterAccount(
                    JSON.stringify(obj),
                    props.influencerPlatformEditData
                      .influencer_accounts_unique_id
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Whatsapp" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPutInfluencerWhatsappAccount(
                    JSON.stringify(obj),
                    props.influencerPlatformEditData
                      .influencer_accounts_unique_id
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });
          } else {
            values.platform.platform_name === "Facebook" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPostInfluencerFacebookAccount(
                    JSON.stringify(obj)
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Instagram" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPostInfluencerInstagramAccount(
                    JSON.stringify(obj)
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Youtube" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPostInfluencerYoutubeAccount(
                    JSON.stringify(obj)
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Quora" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPostInfluencerQuoraAccount(
                    JSON.stringify(obj)
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Playstore" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPostInfluencerPlaystoreAccount(
                    JSON.stringify(obj)
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Twitter" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPostInfluencerTwitterAccount(
                    JSON.stringify(obj)
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });

            values.platform.platform_name === "Whatsapp" &&
              props
                .dispatch(
                  InfluencerPlatformAction.requestPostInfluencerWhatsappAccount(
                    JSON.stringify(obj)
                  )
                )
                .then(() => {
                  let params = {
                    page_limit: 15,
                    order_by: '[["created_on", "desc"]]',
                  };
                  props.dispatch(
                    InfluencerPlatformAction.requestInfluencerPlatforms(params)
                  );
                  props.onClose();
                });
          }
        }}
      >
        {({
          errors,
          isValid,
          helperText,
          touched,
          dirty,
          handleChange,
          setFieldValue,
          values,
        }) => (
          <Form>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <DialogContentText sx={{ width: "100%" }} mb={2}>
                <Box width="100%">
                  <Grid
                    container
                    xl={12}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xl={11} textAlign="center">
                      <h4 className="dailogtext ml-5">
                        {!props.edit ? (
                          <>
                            <span className="span_first_letter">A</span>dd{" "}
                          </>
                        ) : (
                          <>
                            <span className="span_first_letter">E</span>dit{" "}
                          </>
                        )}
                        <span className="span_first_letter">P</span>
                        latform &nbsp;
                        <span className="span_first_letter">A</span>ccounts
                        &nbsp;
                      </h4>
                    </Grid>
                    <Grid item xl={1} textAlign="right">
                      <div className="col-2 closebtn">
                        <i
                          title="Close"
                          className="fa fa-times-circle-o fa-2x"
                          style={{ size: "15px" }}
                          aria-hidden="true"
                          onClick={() => {
                            props.onClose();
                            setTheArray([]);
                            setUrl_value("");
                          }}
                        ></i>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </DialogContentText>

              <Grid container mt={-1} px={2}>
                <Grid item lg={12} md={12} sm={12} container>
                  <Grid item lg={3} md={3} sm={3} mt={3}>
                    Platform :
                  </Grid>
                  <Grid item lg={7} md={6} sm={6}>
                    <Field
                      name="platform"
                      size="small"
                      options={props.platformList ? props.platformList : []}
                      component={AutoCompleteMultiSelect}
                      disableClearable
                      getOptionLabel={(option) =>
                        option.platform_name ? option.platform_name : ""
                      }
                      isOptionEqualToValue={(value, option) =>
                        value.platform_name === option.platform_name
                      }
                      disabled={!props.edit ? false : true}
                      textFieldProps={{
                        margin: "normal",
                        variant: "outlined",
                        placeholder: "Platform",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {(values.platform.platform_name === "Facebook" ||
                values.platform.platform_name === "Quora" ||
                values.platform.platform_name === "Playstore" ||
                values.platform.platform_name === "Twitter" ||
                values.platform.platform_name === "Youtube") && (
                <Grid container>
                  {theArray.length > 0 && (
                    <Grid
                      item
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      container
                      px={2}
                      py={1}
                      // className="bg-warning"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid
                        item
                        xl={3}
                        lg={3}
                        md={1}
                        sm={1}
                        mt={1}
                        // className="bg-success"
                      >
                        Url List :
                      </Grid>

                      <Grid
                        item
                        xl={9}
                        lg={9}
                        md={10.9}
                        sm={10.9}
                        mt={1}
                        p={1}
                        className="text-wrap"
                        sx={{
                          border: "solid 0.5px #d3e2e6",
                          borderRadius: theme.borderRadius,
                          boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.16)",
                        }}
                      >
                        {theArray.map((entry, i) => (
                          <Typography>{`${i + 1}. ${entry}`},&nbsp;</Typography>
                        ))}
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    item
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    container
                    px={2}
                    py={1}
                    // className="bg-warning"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xl={3}
                      lg={3}
                      md={1}
                      sm={1}
                      mt={1}
                      // className="bg-success"
                    >
                      {values.platform.platform_name
                        ? returnKeyname(values.platform.platform_name)
                        : "Add url"}{" "}
                      * :
                    </Grid>
                    <Grid
                      item
                      xl={7}
                      lg={7}
                      md={8.9}
                      sm={8.9}
                      mt={0.2}
                      // className="bg-info"
                    >
                      <Field
                        variant="outlined"
                        as={MuiTextField}
                        id="url"
                        size="small"
                        name="url"
                        placeholder="Url"
                        value={url_value}
                        onChange={url_value_handlechnage}
                        error={
                          theArray.length == 0 &&
                          Boolean(errors.account_url) &&
                          Boolean(touched.account_url)
                        }
                        helperText={
                          theArray.length == 0 &&
                          Boolean(touched.account_url) &&
                          errors.account_url
                        }
                      />
                    </Grid>

                    <Grid item xl={2} lg={2} md={2} sm={2}>
                      <MuiButton
                        width="100%"
                        size="small"
                        name={"Add"}
                        disabled={
                          values.platform.platform_name === "Quora" &&
                          theArray.length === 1
                            ? true
                            : false
                        }
                        onClick={addEntryClick}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {values.platform.platform_name === "Whatsapp" && (
                <Grid container mt={-1} px={2}>
                  <Grid item lg={12} md={12} sm={12} container>
                    <Grid item lg={3} md={3} sm={3} mt={3}>
                      Whatsapp Number :
                    </Grid>
                    <Grid item lg={7} md={6} sm={6} mt={2}>
                      <Field
                        variant="outlined"
                        as={MuiTextField}
                        id="Whatsapp number"
                        size="small"
                        name="whatsapp_number"
                        placeholder="Whatsapp Number"
                        error={
                          Boolean(errors.whatsapp_number) &&
                          Boolean(touched.whatsapp_number)
                        }
                        helperText={
                          Boolean(touched.whatsapp_number) &&
                          errors.whatsapp_number
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <FormControlLabel
                control={<Checkbox checked={values.enabled} />}
                label="Enable/Disable"
                name="enabled"
                value={values.enabled}
                onChange={handleChange}
              />
            </DialogContent>

            <DialogActions className="m-1 mb-4">
              <Grid
                container
                item
                lg={12}
                md={12}
                sm={12}
                display="flex"
                justifyContent="space-evenly"
              >
                <Grid item lg={5} md={5} sm={5} mr={2} minWidth={200}>
                  <MuiButton
                    name={"Submit"}
                    type="submit"
                    width="100%"
                    loading={loading}
                  />
                </Grid>

                <Grid item lg={5} md={5} sm={5} minWidth={200}>
                  <MuiButton
                    name={"Reset"}
                    type="reset"
                    onClick={() => {
                      setTheArray([]);
                      setUrl_value("");
                    }}
                    width="100%"
                  />
                </Grid>
              </Grid>
            </DialogActions>

            <Grid
              container
              item
              // className="bg-warning"
              xl={12}
              alignItems="center"
              justifyContent={"center"}
              mb={4}
            >
              <Grid item xl={1} textAlign="center">
                <IconButton
                  title="Instagram Login"
                  onClick={(event) => {
                    event.stopPropagation();
                    event.ignore = true;

                    requestFacebookToken();
                  }}
                  sx={{ border: "0" }}
                >
                  <InstagramIcon
                    style={{ width: 30, cursor: "pointer", color: "#2a5e6c" }}
                  />
                </IconButton>
              </Grid>

              <Grid item xl={1} textAlign="center">
                <IconButton
                  title="Facebook Login"
                  onClick={(event) => {
                    event.stopPropagation();
                    event.ignore = true;

                    requestFacebookToken();
                  }}
                  sx={{ border: "0" }}
                >
                  <FacebookIcon
                    style={{ width: 30, cursor: "pointer", color: "#2a5e6c" }}
                  />
                </IconButton>
              </Grid>

              <Grid item xl={1} textAlign="center">
                <IconButton
                  title="Youtube Login"
                  onClick={(event) => {
                    event.stopPropagation();
                    event.ignore = true;

                    requestYoutubeToken();
                  }}
                  sx={{ border: "0" }}
                >
                  <YouTubeIcon
                    style={{ width: 30, cursor: "pointer", color: "red" }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default connect(mapDispatchToProps)(PostInfluencersPlatformAccounts);
